/**
 * Punjabi (ਪੰਜਾਬੀ) translations
 */
import { TranslationStrings } from '../types';

export const pa: TranslationStrings = {  common: {
    loading: 'ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...',
    error: 'ਇੱਕ ਗਲਤੀ ਹੋਈ',
    retry: 'ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ',
    cancel: 'ਰੱਦ ਕਰੋ',
    confirm: 'ਪੁਸ਼ਟੀ ਕਰੋ',
    back: 'ਪਿੱਛੇ',
    next: 'ਅੱਗੇ',
    submit: 'ਜਮ੍ਹਾਂ ਕਰੋ',
    done: 'ਹੋ ਗਿਆ',
    close: 'ਬੰਦ ਕਰੋ',
    yes: 'ਹਾਂ',
    no: 'ਨਹੀਂ',
    required: 'ਲੋੜੀਂਦਾ',
    optional: 'ਵਿਕਲਪਿਕ',
  },
  consent: {
    secureConsent: 'ਸੁਰੱਖਿਅਤ ਸਹਿਮਤੀ',
    yourConsentRequired: 'ਤੁਹਾਡੀ ਸਹਿਮਤੀ ਲੋੜੀਂਦੀ ਹੈ',
    consentingAs: 'ਵਜੋਂ ਸਹਿਮਤੀ ਦੇ ਰਹੇ ਹੋ',
    requestingOrg: 'ਬੇਨਤੀ ਕਰਨ ਵਾਲੀ ਸੰਸਥਾ',
    dataBeingCollected: 'ਇਕੱਠਾ ਕੀਤਾ ਜਾ ਰਿਹਾ ਡਾਟਾ',
    purposeOfProcessing: 'ਪ੍ਰੋਸੈਸਿੰਗ ਦਾ ਉਦੇਸ਼',
    whatYouWillDo: 'ਤੁਸੀਂ ਕੀ ਕਰੋਗੇ',
    reviewDocuments: 'ਦਸਤਾਵੇਜ਼ਾਂ ਦੀ ਸਮੀਖਿਆ ਕਰੋ',
    provideConsent: 'ਸਹਿਮਤੀ ਦਿਓ',
    documentsToRead: 'ਪੜ੍ਹਨ ਲਈ ਦਸਤਾਵੇਜ਼',
    estimatedTime: 'ਅੰਦਾਜ਼ਨ ਸਮਾਂ',
    minutes: 'ਮਿੰਟ',
    startReview: 'ਸਮੀਖਿਆ ਸ਼ੁਰੂ ਕਰੋ',
    yourRights: 'DPDP ਐਕਟ 2023 ਅਧੀਨ ਤੁਹਾਡੇ ਅਧਿਕਾਰ',
    rightToAccess: 'ਆਪਣੇ ਡਾਟੇ ਤੱਕ ਪਹੁੰਚ ਕਰਨ ਦਾ ਅਧਿਕਾਰ',
    rightToCorrect: 'ਆਪਣੇ ਡਾਟੇ ਨੂੰ ਠੀਕ ਕਰਨ ਦਾ ਅਧਿਕਾਰ',
    rightToWithdraw: 'ਸਹਿਮਤੀ ਵਾਪਸ ਲੈਣ ਦਾ ਅਧਿਕਾਰ',
    rightToGrievance: 'ਸ਼ਿਕਾਇਤ ਦਰਜ ਕਰਨ ਦਾ ਅਧਿਕਾਰ',
    stepOf: 'ਕਦਮ {current} / {total}',
    pleaseReadCarefully: 'ਕਿਰਪਾ ਕਰਕੇ ਸਹਿਮਤੀ ਦੇਣ ਤੋਂ ਪਹਿਲਾਂ ਹਰ ਦਸਤਾਵੇਜ਼ ਧਿਆਨ ਨਾਲ ਪੜ੍ਹੋ।',
    documentsReviewed: 'ਸਮੀਖਿਆ ਕੀਤੇ ਦਸਤਾਵੇਜ਼',
    remaining: 'ਬਾਕੀ',
    allDocumentsReviewed: 'ਸਾਰੇ ਦਸਤਾਵੇਜ਼ਾਂ ਦੀ ਸਮੀਖਿਆ ਹੋ ਗਈ!',
    clickToRead: "ਪੜ੍ਹਨ ਲਈ ਹਰ ਦਸਤਾਵੇਜ਼ 'ਤੇ ਕਲਿੱਕ ਕਰੋ",
    proceedToConsent: 'ਤੁਸੀਂ ਸਹਿਮਤੀ ਦੇਣ ਲਈ ਅੱਗੇ ਵਧ ਸਕਦੇ ਹੋ',
    markAsRead: 'ਪੜ੍ਹਿਆ ਵਜੋਂ ਚਿੰਨ੍ਹਿਤ ਕਰੋ',
    continueReading: 'ਪੜ੍ਹਨਾ ਜਾਰੀ ਰੱਖੋ',
    confirmConsent: 'ਆਪਣੀ ਸਹਿਮਤੀ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ',
    selectMethod: 'ਤਸਦੀਕ ਵਿਧੀ ਚੁਣੋ',
    iAgreeToTerms: 'ਮੈਂ ਸਾਰੀਆਂ ਸ਼ਰਤਾਂ, ਨੀਤੀਆਂ ਅਤੇ ਸਹਿਮਤੀ ਸਮਝੌਤਿਆਂ ਨਾਲ ਸਹਿਮਤ ਹਾਂ',
    readAllDocuments: 'ਮੈਂ ਸਮਝਦਾ/ਸਮਝਦੀ ਹਾਂ ਕਿ ਮੇਰੀ ਸਹਿਮਤੀ ਸਵੈ-ਇੱਛਤ ਹੈ ਅਤੇ ਕਿਸੇ ਵੀ ਸਮੇਂ ਵਾਪਸ ਲਈ ਜਾ ਸਕਦੀ ਹੈ',
    submitConsent: 'ਸਹਿਮਤੀ ਜਮ੍ਹਾਂ ਕਰੋ',
    submitting: 'ਜਮ੍ਹਾਂ ਹੋ ਰਿਹਾ ਹੈ...',
    digitalSignature: 'ਡਿਜੀਟਲ ਦਸਤਖ਼ਤ',
    smsVerification: 'SMS ਤਸਦੀਕ',
    emailVerification: 'ਈਮੇਲ ਤਸਦੀਕ',
    videoRecording: 'ਵੀਡੀਓ ਰਿਕਾਰਡਿੰਗ',
    audioRecording: 'ਆਡੀਓ ਰਿਕਾਰਡਿੰਗ',
    checkboxConfirmation: 'ਚੈੱਕਬਾਕਸ ਪੁਸ਼ਟੀ',
    drawSignature: 'ਆਪਣੇ ਦਸਤਖ਼ਤ ਬਣਾਓ',
    verifyViaSms: 'SMS ਕੋਡ ਰਾਹੀਂ ਤਸਦੀਕ ਕਰੋ',
    verifyViaEmail: 'ਈਮੇਲ ਕੋਡ ਰਾਹੀਂ ਤਸਦੀਕ ਕਰੋ',
    recordVideoConsent: 'ਵੀਡੀਓ ਸਹਿਮਤੀ ਰਿਕਾਰਡ ਕਰੋ',
    recordAudioConsent: 'ਆਡੀਓ ਸਹਿਮਤੀ ਰਿਕਾਰਡ ਕਰੋ',
    confirmByChecking: 'ਚੈੱਕ ਕਰਕੇ ਪੁਸ਼ਟੀ ਕਰੋ',
    enterOtp: 'OTP ਦਾਖਲ ਕਰੋ',
    otpSentTo: 'OTP ਭੇਜਿਆ ਗਿਆ',
    resendOtp: 'OTP ਦੁਬਾਰਾ ਭੇਜੋ',
    verifyOtp: 'OTP ਤਸਦੀਕ ਕਰੋ',
    otpVerified: 'OTP ਤਸਦੀਕ ਹੋਇਆ',
    invalidOtp: 'ਅਵੈਧ OTP',
    startRecording: 'ਰਿਕਾਰਡਿੰਗ ਸ਼ੁਰੂ ਕਰੋ',
    stopRecording: 'ਰਿਕਾਰਡਿੰਗ ਬੰਦ ਕਰੋ',
    retake: 'ਦੁਬਾਰਾ ਲਓ',
    recordingComplete: 'ਰਿਕਾਰਡਿੰਗ ਪੂਰੀ',
    consentSubmitted: 'ਸਹਿਮਤੀ ਸਫਲਤਾਪੂਰਵਕ ਜਮ੍ਹਾਂ ਹੋਈ',
    thankYou: 'ਸਹਿਮਤੀ ਦੇਣ ਲਈ ਧੰਨਵਾਦ',
    confirmationSent: "ਤੁਹਾਡੀ ਈਮੇਲ 'ਤੇ ਪੁਸ਼ਟੀ ਭੇਜੀ ਗਈ ਹੈ",
    referenceNumber: 'ਹਵਾਲਾ ਨੰਬਰ',
    errorSubmitting: 'ਸਹਿਮਤੀ ਜਮ੍ਹਾਂ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।',
    pleaseReadDocs: 'ਕਿਰਪਾ ਕਰਕੇ ਪਹਿਲਾਂ ਸਾਰੇ ਦਸਤਾਵੇਜ਼ ਪੜ੍ਹੋ',
    pleaseProvideEvidence: 'ਕਿਰਪਾ ਕਰਕੇ ਸਹਿਮਤੀ ਸਬੂਤ ਦਿਓ',
  },
  documents: {
    privacyPolicy: 'ਗੋਪਨੀਯਤਾ ਨੀਤੀ',
    termsOfService: 'ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ',
    consentAgreement: 'ਸਹਿਮਤੀ',
    dataSharingAgreement: 'ਡਾਟਾ ਸਾਂਝਾ ਕਰਨ ਦਾ ਸਮਝੌਤਾ',
    cookiePolicy: 'ਕੂਕੀ ਨੀਤੀ',
    retentionPolicy: 'ਡਾਟਾ ਧਾਰਨ ਨੀਤੀ',
    gdprNotice: 'GDPR ਨੋਟਿਸ',
    hipaaAuthorization: 'HIPAA ਅਧਿਕਾਰ',
    ccpaDisclosure: 'CCPA ਖੁਲਾਸਾ',
    aadhaarAuthorization: 'ਆਧਾਰ ਅਧਿਕਾਰ',
    customDocument: 'ਕਸਟਮ ਦਸਤਾਵੇਜ਼',
  },
  dataCategories: {
    personalInfo: 'ਨਿੱਜੀ ਜਾਣਕਾਰੀ',
    contactDetails: 'ਸੰਪਰਕ ਵੇਰਵੇ',
    financialInfo: 'ਵਿੱਤੀ ਜਾਣਕਾਰੀ',
    healthData: 'ਸਿਹਤ ਅਤੇ ਮੈਡੀਕਲ ਡਾਟਾ',
    biometricData: 'ਬਾਇਓਮੈਟ੍ਰਿਕ ਡਾਟਾ',
    locationData: 'ਟਿਕਾਣਾ ਡਾਟਾ',
    behavioralData: 'ਵਿਹਾਰਕ ਡਾਟਾ',
    communicationData: 'ਸੰਚਾਰ ਡਾਟਾ',
    employmentInfo: 'ਰੁਜ਼ਗਾਰ ਜਾਣਕਾਰੀ',
    educationInfo: 'ਵਿਦਿਅਕ ਜਾਣਕਾਰੀ',
  },
  a11y: {
    mainContent: 'ਮੁੱਖ ਸਮੱਗਰੀ',
    navigation: 'ਨੈਵੀਗੇਸ਼ਨ',
    closeModal: 'ਮੋਡਲ ਬੰਦ ਕਰੋ',
    expandSection: 'ਸੈਕਸ਼ਨ ਫੈਲਾਓ',
    collapseSection: 'ਸੈਕਸ਼ਨ ਸੁੰਗੜੋ',
    documentRead: 'ਦਸਤਾਵੇਜ਼ ਪੜ੍ਹਿਆ ਵਜੋਂ ਚਿੰਨ੍ਹਿਤ',
    documentUnread: 'ਦਸਤਾਵੇਜ਼ ਅਜੇ ਨਹੀਂ ਪੜ੍ਹਿਆ',
    progressIndicator: 'ਤਰੱਕੀ: {current} / {total} ਦਸਤਾਵੇਜ਼ ਪੜ੍ਹੇ',
    signaturePad: 'ਦਸਤਖ਼ਤ ਖੇਤਰ',
    clearSignature: 'ਦਸਤਖ਼ਤ ਸਾਫ਼ ਕਰੋ',
    videoPlayer: 'ਵੀਡੀਓ ਰਿਕਾਰਡਿੰਗ ਪਲੇਅਰ',
    audioPlayer: 'ਆਡੀਓ ਰਿਕਾਰਡਿੰਗ ਪਲੇਅਰ',
    requiredField: 'ਇਹ ਫੀਲਡ ਲੋੜੀਂਦੀ ਹੈ',
    errorMessage: 'ਗਲਤੀ',
    successMessage: 'ਸਫਲਤਾ',
    loadingContent: 'ਸਮੱਗਰੀ ਲੋਡ ਹੋ ਰਹੀ ਹੈ, ਕਿਰਪਾ ਕਰਕੇ ਉਡੀਕ ਕਰੋ',
    newWindow: 'ਨਵੀਂ ਵਿੰਡੋ ਵਿੱਚ ਖੁੱਲ੍ਹਦਾ ਹੈ',
  },
  portal: {
    // General
    myConsents: 'ਮੇਰੀਆਂ ਸਹਿਮਤੀਆਂ',
    viewManageConsents: 'ਆਪਣੇ ਸਹਿਮਤੀ ਰਿਕਾਰਡ ਦੇਖੋ ਅਤੇ ਪ੍ਰਬੰਧਿਤ ਕਰੋ',
    logout: 'ਲੌਗਆਊਟ',
    welcomeBack: 'ਵਾਪਸ ਸਵਾਗਤ ਹੈ',
    
    // Tenant selector
    organizationNameOrCode: 'ਸੰਸਥਾ ਦਾ ਨਾਮ ਜਾਂ ਕੋਡ',
    orgPlaceholder: 'ਜਿਵੇਂ, globalhealth ਜਾਂ acme-corp',
    orgHint: 'ਆਪਣੀ ਸੰਸਥਾ ਦੁਆਰਾ ਦਿੱਤਾ ਨਾਮ ਜਾਂ ਕੋਡ ਦਰਜ ਕਰੋ',
    findMyOrganization: 'ਮੇਰੀ ਸੰਸਥਾ ਲੱਭੋ',
    orgNotFound: 'ਸੰਸਥਾ ਨਹੀਂ ਮਿਲੀ। ਕਿਰਪਾ ਕਰਕੇ ਨਾਮ ਜਾਂਚੋ ਅਤੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।',
    enterOrgName: 'ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੀ ਸੰਸਥਾ ਦਾ ਨਾਮ ਜਾਂ ਕੋਡ ਦਰਜ ਕਰੋ',
    or: 'ਜਾਂ',
    haveDirectLink: 'ਤੁਹਾਡੀ ਸੰਸਥਾ ਤੋਂ ਸਿੱਧਾ ਲਿੰਕ ਹੈ?',
    useDirectLink: 'ਉਨ੍ਹਾਂ ਦੁਆਰਾ ਦਿੱਤਾ ਲਿੰਕ ਵਰਤੋ',
    privacyProtected: 'ਤੁਹਾਡੀ ਗੋਪਨੀਯਤਾ ਕਾਨੂੰਨ ਦੁਆਰਾ ਸੁਰੱਖਿਅਤ ਹੈ',
    
    // Login flow
    phoneOrEmail: 'ਫ਼ੋਨ ਨੰਬਰ ਜਾਂ ਈਮੇਲ',
    enterPhoneOrEmailPlaceholder: 'ਆਪਣਾ ਰਜਿਸਟਰਡ ਫ਼ੋਨ ਜਾਂ ਈਮੇਲ ਦਰਜ ਕਰੋ',
    otpWillBeSent: 'ਅਸੀਂ ਤੁਹਾਨੂੰ ਵਨ-ਟਾਈਮ ਪਾਸਵਰਡ (OTP) ਭੇਜਾਂਗੇ',
    sendOtp: 'OTP ਭੇਜੋ',
    enterPhoneOrEmail: 'ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਫ਼ੋਨ ਨੰਬਰ ਜਾਂ ਈਮੇਲ ਦਰਜ ਕਰੋ',
    otpSentTo: 'OTP ਭੇਜਿਆ ਗਿਆ',
    expiresIn: 'ਖਤਮ ਹੋਵੇਗਾ',
    enterOtp: 'OTP ਦਰਜ ਕਰੋ',
    enterValidOtp: 'ਕਿਰਪਾ ਕਰਕੇ ਵੈਧ OTP ਦਰਜ ਕਰੋ',
    verifyOtp: 'OTP ਤਸਦੀਕ ਕਰੋ',
    resendOtp: 'OTP ਦੁਬਾਰਾ ਭੇਜੋ',
    otpVerified: 'OTP ਤਸਦੀਕ ਹੋਇਆ',
    oneMoreStep: 'ਤੁਹਾਡੀ ਪਛਾਣ ਤਸਦੀਕ ਕਰਨ ਲਈ ਇੱਕ ਹੋਰ ਕਦਮ',
    enterSecurityAnswer: 'ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਜਵਾਬ ਦਰਜ ਕਰੋ',
    enterAnswer: 'ਜਵਾਬ ਦਰਜ ਕਰੋ',
    dobFormat: 'ਫਾਰਮੈਟ: DDMMYYYY (ਜਿਵੇਂ, 15051990 ਮਈ 15, 1990)',
    login: 'ਲੌਗਇਨ',
    startOver: 'ਦੁਬਾਰਾ ਸ਼ੁਰੂ ਕਰੋ',
    needHelp: 'ਮਦਦ ਚਾਹੀਦੀ ਹੈ?',
    privacyNotice: 'ਤੁਹਾਡਾ ਡਾਟਾ ਲਾਗੂ ਗੋਪਨੀਯਤਾ ਕਾਨੂੰਨਾਂ ਅਧੀਨ ਸੁਰੱਖਿਅਤ ਹੈ',
    checkUrlOrContact: 'ਕਿਰਪਾ ਕਰਕੇ URL ਜਾਂਚੋ ਜਾਂ ਆਪਣੀ ਸੰਸਥਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।',
    
    // Consent history
    filterAll: 'ਸਾਰੇ',
    statusActive: 'ਸਰਗਰਮ',
    statusWithdrawn: 'ਵਾਪਸ ਲਿਆ',
    statusExpired: 'ਮਿਆਦ ਪੁੱਗੀ',
    noConsents: 'ਕੋਈ ਸਹਿਮਤੀ ਰਿਕਾਰਡ ਨਹੀਂ ਮਿਲੇ',
    noConsentsWithFilter: 'ਇਸ ਸਥਿਤੀ ਵਿੱਚ ਕੋਈ ਸਹਿਮਤੀ ਨਹੀਂ',
    consentedOn: 'ਸਹਿਮਤੀ ਦਿੱਤੀ',
    expiresOn: 'ਮਿਆਦ ਖਤਮ ਹੋਵੇਗੀ',
    withdrawnOn: 'ਵਾਪਸ ਲਿਆ',
    withdrawConsent: 'ਸਹਿਮਤੀ ਵਾਪਸ ਲਓ',
    withdrawalHistory: 'ਵਾਪਸੀ ਇਤਿਹਾਸ',
    help: 'ਮਦਦ',
    
    // Withdrawal
    cannotWithdraw: 'ਇਹ ਸਹਿਮਤੀ ਵਾਪਸ ਨਹੀਂ ਲਈ ਜਾ ਸਕਦੀ',
    pleaseConfirmWithdrawal: 'ਕਿਰਪਾ ਕਰਕੇ ਪੁਸ਼ਟੀ ਕਰੋ ਕਿ ਤੁਸੀਂ ਨਤੀਜੇ ਸਮਝਦੇ ਹੋ',
    importantNotice: 'ਮਹੱਤਵਪੂਰਨ ਨੋਟਿਸ',
    withdrawalNotice1: 'ਸੰਸਥਾ ਦੱਸੇ ਗਏ ਉਦੇਸ਼ਾਂ ਲਈ ਤੁਹਾਡੇ ਡਾਟੇ ਦੀ ਪ੍ਰੋਸੈਸਿੰਗ ਬੰਦ ਕਰ ਦੇਵੇਗੀ।',
    withdrawalNotice2: 'ਕਾਨੂੰਨੀ ਪਾਲਣਾ ਲਈ ਕੁਝ ਡਾਟਾ ਰੱਖਿਆ ਜਾ ਸਕਦਾ ਹੈ।',
    withdrawalNotice3: 'ਕੁਝ ਸੇਵਾਵਾਂ ਵਰਤਣ ਲਈ ਤੁਹਾਨੂੰ ਦੁਬਾਰਾ ਸਹਿਮਤੀ ਦੇਣੀ ਪੈ ਸਕਦੀ ਹੈ।',
    withdrawalNotice4: 'ਲਾਗੂ ਕਾਨੂੰਨਾਂ ਅਨੁਸਾਰ ਪ੍ਰੋਸੈਸਿੰਗ ਸਮਾਂ 7-30 ਦਿਨ ਲੱਗ ਸਕਦਾ ਹੈ।',
    withdrawalReason: 'ਵਾਪਸੀ ਦਾ ਕਾਰਨ',
    withdrawalReasonPlaceholder: 'ਦੱਸੋ ਤੁਸੀਂ ਕਿਉਂ ਵਾਪਸ ਲੈਣਾ ਚਾਹੁੰਦੇ ਹੋ (ਵਿਕਲਪਿਕ)',
    withdrawalConfirmation: 'ਮੈਂ ਸਮਝਦਾ/ਸਮਝਦੀ ਹਾਂ ਕਿ ਮੇਰੀ ਸਹਿਮਤੀ ਵਾਪਸ ਲੈਣ ਨਾਲ ਕੁਝ ਸੇਵਾਵਾਂ ਵਰਤਣ ਦੀ ਮੇਰੀ ਯੋਗਤਾ ਪ੍ਰਭਾਵਿਤ ਹੋ ਸਕਦੀ ਹੈ, ਅਤੇ ਮੈਂ ਇਸ ਬੇਨਤੀ ਨਾਲ ਅੱਗੇ ਵਧਣਾ ਚਾਹੁੰਦਾ/ਚਾਹੁੰਦੀ ਹਾਂ।',
    submitWithdrawalRequest: 'ਵਾਪਸੀ ਬੇਨਤੀ ਜਮ੍ਹਾਂ ਕਰੋ',
    withdrawalSubmitted: 'ਵਾਪਸੀ ਬੇਨਤੀ ਜਮ੍ਹਾਂ ਹੋ ਗਈ',
    withdrawalSubmittedDesc: 'ਤੁਹਾਡੀ ਵਾਪਸੀ ਬੇਨਤੀ ਜਮ੍ਹਾਂ ਹੋ ਗਈ ਹੈ। ਸੰਸਥਾ ਦੁਆਰਾ ਪ੍ਰੋਸੈਸ ਕਰਨ ਤੋਂ ਬਾਅਦ ਤੁਹਾਨੂੰ ਸੂਚਿਤ ਕੀਤਾ ਜਾਵੇਗਾ।',
    processingTime: 'ਪ੍ਰੋਸੈਸਿੰਗ ਸਮਾਂ',
    days: 'ਦਿਨ',
    backToHistory: 'ਸਹਿਮਤੀ ਇਤਿਹਾਸ ਤੇ ਵਾਪਸ ਜਾਓ',
    
    // Withdrawal history
    statusPending: 'ਬਕਾਇਆ',
    statusApproved: 'ਮਨਜ਼ੂਰ',
    statusRejected: 'ਰੱਦ',
    noWithdrawals: 'ਕੋਈ ਵਾਪਸੀ ਬੇਨਤੀਆਂ ਨਹੀਂ',
    viewConsents: 'ਆਪਣੀਆਂ ਸਹਿਮਤੀਆਂ ਦੇਖੋ',
    requestedOn: 'ਬੇਨਤੀ ਕੀਤੀ',
    processedOn: 'ਪ੍ਰੋਸੈਸ ਕੀਤਾ',
    processingMessage: 'ਤੁਹਾਡੀ ਬੇਨਤੀ ਪ੍ਰੋਸੈਸ ਹੋ ਰਹੀ ਹੈ। ਮੁਕੰਮਲ ਹੋਣ ਤੇ ਤੁਹਾਨੂੰ ਸੂਚਿਤ ਕੀਤਾ ਜਾਵੇਗਾ।',
    processingTimeInfo: 'ਪ੍ਰੋਸੈਸਿੰਗ ਸਮਾਂ ਜਾਣਕਾਰੀ',
    
    // Help section
    yourRights: 'ਤੁਹਾਡੇ ਗੋਪਨੀਯਤਾ ਅਧਿਕਾਰ',
    helpTitle: 'ਆਪਣੇ ਗੋਪਨੀਯਤਾ ਅਧਿਕਾਰਾਂ ਨੂੰ ਸਮਝੋ',
    helpSubtitle: 'ਗੋਪਨੀਯਤਾ ਕਾਨੂੰਨਾਂ ਅਧੀਨ ਆਪਣੇ ਅਧਿਕਾਰਾਂ ਅਤੇ ਸਹਿਮਤੀ ਨੂੰ ਕਿਵੇਂ ਪ੍ਰਬੰਧਿਤ ਕਰਨਾ ਹੈ ਬਾਰੇ ਜਾਣੋ।',
    quickActions: 'ਤੇਜ਼ ਕਾਰਵਾਈਆਂ',
    viewMyConsents: 'ਮੇਰੀਆਂ ਸਹਿਮਤੀਆਂ ਦੇਖੋ',
    viewWithdrawalRequests: 'ਵਾਪਸੀ ਬੇਨਤੀਆਂ ਦੇਖੋ',
    loginToViewConsents: 'ਆਪਣੀਆਂ ਸਹਿਮਤੀਆਂ ਦੇਖਣ ਲਈ ਲੌਗਇਨ ਕਰੋ',
    applicableLaws: 'ਲਾਗੂ ਗੋਪਨੀਯਤਾ ਕਾਨੂੰਨ',
    
    // Rights FAQ
    rightAccessQ: 'ਪਹੁੰਚ ਅਧਿਕਾਰ ਕੀ ਹੈ?',
    rightAccessA: 'ਤੁਹਾਡੇ ਬਾਰੇ ਕਿਹੜਾ ਨਿੱਜੀ ਡਾਟਾ ਇਕੱਠਾ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ, ਇਹ ਕਿਵੇਂ ਵਰਤਿਆ ਜਾ ਰਿਹਾ ਹੈ, ਕਿਸ ਨਾਲ ਸਾਂਝਾ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ ਜਾਣਨ ਦਾ ਤੁਹਾਡਾ ਅਧਿਕਾਰ ਹੈ।',
    rightCorrectQ: 'ਸੁਧਾਰ ਅਧਿਕਾਰ ਕੀ ਹੈ?',
    rightCorrectA: 'ਜੇ ਤੁਹਾਡਾ ਨਿੱਜੀ ਡਾਟਾ ਗਲਤ ਜਾਂ ਅਧੂਰਾ ਹੈ, ਤੁਸੀਂ ਇਸਨੂੰ ਸੁਧਾਰਨ ਜਾਂ ਅੱਪਡੇਟ ਕਰਨ ਦੀ ਬੇਨਤੀ ਕਰ ਸਕਦੇ ਹੋ।',
    rightWithdrawQ: 'ਸਹਿਮਤੀ ਵਾਪਸ ਲੈਣ ਦਾ ਅਧਿਕਾਰ ਕੀ ਹੈ?',
    rightWithdrawA: 'ਤੁਸੀਂ ਕਿਸੇ ਵੀ ਸਮੇਂ ਆਪਣੀ ਸਹਿਮਤੀ ਵਾਪਸ ਲੈ ਸਕਦੇ ਹੋ। ਵਾਪਸ ਲੈਣ ਤੋਂ ਬਾਅਦ, ਜਿਨ੍ਹਾਂ ਉਦੇਸ਼ਾਂ ਲਈ ਤੁਸੀਂ ਸਹਿਮਤੀ ਦਿੱਤੀ ਸੀ ਉਨ੍ਹਾਂ ਲਈ ਤੁਹਾਡੇ ਡਾਟੇ ਦੀ ਪ੍ਰੋਸੈਸਿੰਗ ਬੰਦ ਕਰਨੀ ਪਵੇਗੀ।',
    rightEraseQ: 'ਮਿਟਾਉਣ ਦਾ ਅਧਿਕਾਰ ਕੀ ਹੈ?',
    rightEraseA: '"ਭੁੱਲ ਜਾਣ ਦਾ ਅਧਿਕਾਰ" ਵਜੋਂ ਵੀ ਜਾਣਿਆ ਜਾਂਦਾ ਹੈ, ਤੁਸੀਂ ਆਪਣਾ ਨਿੱਜੀ ਡਾਟਾ ਮਿਟਾਉਣ ਦੀ ਬੇਨਤੀ ਕਰ ਸਕਦੇ ਹੋ। ਹਾਲਾਂਕਿ, ਕੁਝ ਜਾਣਕਾਰੀ ਰੱਖਣ ਲਈ ਕਾਨੂੰਨੀ ਕਾਰਨ ਹੋ ਸਕਦੇ ਹਨ।',
    
    // Withdrawal FAQ
    withdrawalFaq: 'ਵਾਪਸੀ ਪ੍ਰਕਿਰਿਆ',
    withdrawHowQ: 'ਮੈਂ ਆਪਣੀ ਸਹਿਮਤੀ ਕਿਵੇਂ ਵਾਪਸ ਲਵਾਂ?',
    withdrawHowA: 'ਆਪਣੇ ਖਾਤੇ ਵਿੱਚ ਲੌਗਇਨ ਕਰੋ, ਸਹਿਮਤੀ ਇਤਿਹਾਸ ਤੇ ਜਾਓ, ਸਰਗਰਮ ਸਹਿਮਤੀ ਤੇ "ਸਹਿਮਤੀ ਵਾਪਸ ਲਓ" ਕਲਿੱਕ ਕਰੋ।',
    withdrawTimeQ: 'ਵਾਪਸ ਲੈਣ ਵਿੱਚ ਕਿੰਨਾ ਸਮਾਂ ਲੱਗਦਾ ਹੈ?',
    withdrawTimeA: 'ਲਾਗੂ ਕਾਨੂੰਨਾਂ ਅਨੁਸਾਰ ਪ੍ਰੋਸੈਸਿੰਗ ਸਮਾਂ: DPDP ਐਕਟ (ਭਾਰਤ) - 7 ਦਿਨ, GDPR (EU) - 30 ਦਿਨ, CCPA (ਕੈਲੀਫੋਰਨੀਆ) - 45 ਦਿਨ।',
    withdrawEffectQ: 'ਸਹਿਮਤੀ ਵਾਪਸ ਲੈਣ ਤੋਂ ਬਾਅਦ ਕੀ ਹੁੰਦਾ ਹੈ?',
    withdrawEffectA: 'ਦੱਸੇ ਗਏ ਉਦੇਸ਼ਾਂ ਲਈ ਤੁਹਾਡਾ ਡਾਟਾ ਵਰਤਣਾ ਸੰਸਥਾ ਬੰਦ ਕਰ ਦੇਵੇਗੀ। ਕਾਨੂੰਨੀ ਪਾਲਣਾ ਲਈ ਕੁਝ ਡਾਟਾ ਰੱਖਿਆ ਜਾ ਸਕਦਾ ਹੈ।',
    
    // Security FAQ
    securityFaq: 'ਖਾਤਾ ਸੁਰੱਖਿਆ',
    loginSecureQ: 'ਮੇਰਾ ਲੌਗਇਨ ਕਿਵੇਂ ਸੁਰੱਖਿਅਤ ਹੈ?',
    loginSecureA: 'ਅਸੀਂ 3-ਕਦਮ ਤਸਦੀਕ ਪ੍ਰਕਿਰਿਆ ਵਰਤਦੇ ਹਾਂ: ਰਜਿਸਟਰਡ ਫ਼ੋਨ/ਈਮੇਲ ਤੇ OTP, ਫਿਰ ਸੁਰੱਖਿਆ ਸਵਾਲ।',
    dataProtectQ: 'ਮੇਰਾ ਡਾਟਾ ਕਿਵੇਂ ਸੁਰੱਖਿਅਤ ਹੈ?',
    dataProtectA: 'ਸਾਰਾ ਡਾਟਾ ਟ੍ਰਾਂਜ਼ਿਟ ਅਤੇ ਰੈਸਟ ਵਿੱਚ ਇਨਕ੍ਰਿਪਟ ਕੀਤਾ ਜਾਂਦਾ ਹੈ। DPDP ਐਕਟ, GDPR ਅਤੇ ਹੋਰ ਗੋਪਨੀਯਤਾ ਨਿਯਮਾਂ ਦੀ ਪਾਲਣਾ ਕਰਦੇ ਹਾਂ।',
    
    // Contact FAQ
    contactFaq: 'ਸੰਪਰਕ ਅਤੇ ਸਹਾਇਤਾ',
    grievanceQ: 'ਸ਼ਿਕਾਇਤ ਕਿਵੇਂ ਦਰਜ ਕਰੀਏ?',
    grievanceA: 'ਸੰਸਥਾ ਦੇ ਡਾਟਾ ਪ੍ਰੋਟੈਕਸ਼ਨ ਅਫ਼ਸਰ (DPO) ਜਾਂ ਸ਼ਿਕਾਇਤ ਅਫ਼ਸਰ ਨਾਲ ਸੰਪਰਕ ਕਰ ਸਕਦੇ ਹੋ।',
    regulatorQ: 'ਰੈਗੂਲੇਟਰੀ ਅਥਾਰਟੀ ਕੌਣ ਹੈ?',
    regulatorA: 'ਭਾਰਤ ਵਿੱਚ, ਡਾਟਾ ਪ੍ਰੋਟੈਕਸ਼ਨ ਬੋਰਡ ਗੋਪਨੀਯਤਾ ਸ਼ਿਕਾਇਤਾਂ ਸੰਭਾਲਦਾ ਹੈ। EU ਵਿੱਚ, ਆਪਣੀ ਰਾਸ਼ਟਰੀ ਡਾਟਾ ਪ੍ਰੋਟੈਕਸ਼ਨ ਅਥਾਰਟੀ ਨਾਲ ਸੰਪਰਕ ਕਰ ਸਕਦੇ ਹੋ।',
  },
}
;
